module.exports = __webpack_public_path__ + "img/shouye.bcfa16ed.svg";